export function avg(ratings) {
  if (!ratings || !ratings.length) return 0;
  const vals = ratings.map(r => r.rating);
  return (vals.reduce((a, b) => a + b, 0) / vals.length).toFixed(1);
}

export function stars(n) {
  const val = Math.round(parseFloat(n) * 2) / 2;
  const full = Math.floor(val);
  const half = (val % 1) >= 0.5;
  const empty = 5 - full - (half ? 1 : 0);
  return (
    <>
      {'★'.repeat(full)}
      {half && (
        <span style={{ position: 'relative', display: 'inline-block', color: '#ddd' }}>
          ★<span style={{ position: 'absolute', left: 0, top: 0, width: '50%', overflow: 'hidden', color: 'var(--gold)' }}>★</span>
        </span>
      )}
      <span style={{ color: '#ddd' }}>{'★'.repeat(empty)}</span>
    </>
  );
}

export function badgeClass(type) {
  if (type === 'Rött') return 'badge-rod';
  if (type === 'Vitt') return 'badge-vit';
  if (type === 'Rosé') return 'badge-rose';
  if (type === 'Mousserande') return 'badge-mous';
  return 'badge-rod';
}

export function sweDate(dateStr) {
  if (!dateStr) return '';
  const months = ['jan','feb','mar','apr','maj','jun','jul','aug','sep','okt','nov','dec'];
  const d = new Date(dateStr);
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
}

export function thisYear() {
  return new Date().getFullYear();
}
